import { defineRecipe } from "@chakra-ui/react-v3";

export const kbdRecipe = defineRecipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    fontWeight: "medium",
    fontFamily: "mono",
    flexShrink: 0,
    whiteSpace: "nowrap",
    wordSpacing: "-0.5em",
    userSelect: "none",
    px: "1",
    borderRadius: "md",
    justifyContent: "center",
  },

  variants: {
    variant: {
      subtle: {
        bg: "neutral.muted",
        color: "fg.emphasized",
      },
      outline: {
        borderWidth: "1px",
        color: "fg.emphasized",
      },
      plain: {
        color: "fg.emphasized",
      },
    },

    size: {
      sm: {
        textStyle: "body.12",
        h: "4.5",
        minW: "4.5",
      },
      md: {
        textStyle: "body.12",
        h: "5",
        minW: "5",
      },
      lg: {
        textStyle: "body.14",
        h: "6",
        minW: "6",
      },
    },
  },

  defaultVariants: {
    size: "md",
    variant: "subtle",
  },
});
